declare global {
    interface Window {
        cioanalytics: any;
    }
}

interface UserAttributes {
    email: string;
    name?: string;
    id?: string;
    created_at?: string | number;
    [key: string]: any; // Allow any additional attributes
}

const customerioIdentify = (email: string, attributes: UserAttributes = { email: '' }) => {
    if (typeof window !== 'undefined' && window.cioanalytics) {
        window.cioanalytics.identify(email, {
            email: email,
            ...attributes
        });
        console.log('Customer.io: User identified', email);
    }
}



const customerioTrack = (event: string, properties: Record<string, any> = {}) => {
    if (typeof window !== 'undefined' && window.cioanalytics) {
        window.cioanalytics.track(event, properties);
        console.log('Customer.io: Tracked event', event, properties);
    }

}

const customerioReset = () => {
    if (typeof window !== 'undefined' && window.cioanalytics) {
        window.cioanalytics.reset();
    }
}

export { customerioIdentify, customerioReset, customerioTrack };
